var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatasetIndex',{staticClass:"dataset-index",attrs:{"history_dataset_id":_vm.args.history_dataset_id,"path":_vm.args.path}})}
var staticRenderFns = []

export { render, staticRenderFns }